// ─── In-memory session token (DASH-024) ─────────────────────────────────────
// The admin session now lives in an httpOnly cookie set by the backend, which
// JavaScript (and therefore XSS) cannot read. We deliberately DO NOT persist the
// JWT to localStorage anymore.
//
// This module holds the token in memory for the lifetime of the tab only, used
// as a same-tab fallback: it's sent as `x-access-token` so that if the cookie is
// somehow not delivered, the session still works and nobody gets locked out. It
// is intentionally lost on reload — the cookie restores the session via /auth/me.
let _token = null;

export function setSessionToken(t) {
  _token = t ? (t.startsWith("Bearer ") ? t.slice(7) : t) : null;
}

export function getSessionToken() {
  return _token;
}

export function clearSessionToken() {
  _token = null;
}
